export default __webpack_public_path__ + "static/media/profile1.6fdecdd7.jpg";